import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.xl};
`;

export const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 1.6rem;
  padding: ${({ theme }) => theme.spacing.xxl};
  max-width: 40rem;
  width: 100%;
  text-align: center;
`;

export const Icon = styled.div`
  font-size: 5.6rem;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

export const Title = styled.div`
  font-size: 2.2rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const Subtitle = styled.div`
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  line-height: 1.5;
`;
